<div class="h-full flex flex-column">
    <div class="flex flex-1 flex-column align-items-center justify-content-center">
        <img src="assets/images/unauthorized.svg" />
        <p class="text-bold text-2xl">Oops! You don’t have permission to view this page</p>
        <p class="text-md">Either contact your admin or log in with a different user account.</p>
        <p-button
            class="mt-2"
            label="Log out and login as different user"
            [text]="true"
            (onClick)="redirectToLogin()"
        ></p-button>
    </div>
</div>
